<template>
    <div>
        <b-overlay :show="loading" opacity="0.6">
            <div class="header-img with-bg" :style="{ backgroundImage: 'url(' + categoryDetails.categoryImage + ')' }">
                <h1 class="page-title">{{categoryDetails.name}}.</h1>
            </div>

                <b-container class="menu-container pt-4">
                    <ul class="menu-items-container">
                        <li class="menu-item"
                            v-for="(sub_category, index) in categoryDetails.sub_categories"
                            :key="index">
                            <router-link :to="{path: `/menu/${category_id}/${sub_category.id}`}">
                                <div class="item-meta">
                                    <h5 class="mb-0">{{ sub_category.name }}</h5></div>
                            </router-link>
                        </li>
                    </ul>
                </b-container>
        </b-overlay>
    </div>
</template>

<script>
    export default {
        name: "Menu",
        data() {
            return {
                loading: false,
                category_id: this.$route.params.category_id,
                categoryDetails: '',
            }
        },

        mounted() {
            this.getCategoryDetails()
        },

        methods: {

            getCategoryDetails() {
                this.loading = true;
                console.log("Loading data...");
                axios.get('/item/category/' + this.category_id).then(response => {
                    console.log("loaded category details & sub categories.")
                    this.categoryDetails = response.data;
                    this.loading = false;
                })
            },
        }

    }
</script>

<style scoped lang="scss">
    .slide-in {

        &-move {
            transition: opacity .5s linear, transform .5s ease-in-out;
        }

        &-leave-active {
            transition: opacity .4s linear, transform .4s cubic-bezier(.5, 0, .7, .4); //cubic-bezier(.7,0,.7,1);
            transition-delay: calc(0.1s * (var(--total) - var(--i)));
        }

        &-enter-active {
            transition: opacity .5s linear, transform .5s cubic-bezier(.2, .5, .1, 1);
            transition-delay: calc(0.1s * var(--i));
        }

        &-enter,
        &-leave-to {
            opacity: 0;
        }

        &-enter {
            transform: translateX(-1em);
        }

        &-leave-to {
            transform: translateX(1em);
        }

    }


</style>